export function parseJson(str) {
  try {
    return JSON.parse(str);
  } catch (e) {
    console.error('Error parsing JSON:', e);
    return {};
  }
}

export function escapeFilterValue(value) {
  return String(value).replace(/\\/g, '\\\\').replace(/'/g, "\\'");
}

export function buildFilterString(filters) {
  const parts = Object.entries(filters)
    .filter(
      ([, values]) =>
        values && (Array.isArray(values) ? values.length > 0 : true),
    )
    .map(([key, values]) => {
      if (Array.isArray(values)) {
        const orParts = values
          .map((value) => `${key}:'${escapeFilterValue(value)}'`)
          .join(' OR ');
        return `(${orParts})`;
      }
      return `${key}:'${escapeFilterValue(values)}'`;
    });

  return parts.join(' AND ');
}

export function buildCompleteFilterString(siteId, customFilters = {}) {
  const filterParts = [];

  if (siteId) {
    filterParts.push(`siteId:${siteId}`);
  }

  const customFilterString = buildFilterString(customFilters);
  if (customFilterString) {
    filterParts.push(customFilterString);
  }

  return filterParts.join(' AND ');
}
